import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

const PromoCodeHandler = () => {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const promoCode = searchParams.get("promo_code")
    if (promoCode) {
      localStorage.setItem("promo_code", promoCode)
    }
    window.location.href = "https://getvibrato.com"
  }, [searchParams])

  return null
}

export default PromoCodeHandler
